import { render, staticRenderFns } from "./BFormOOI.vue?vue&type=template&id=0ae6dcd5&scoped=true&"
import script from "./BFormOOI.vue?vue&type=script&lang=js&"
export * from "./BFormOOI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae6dcd5",
  null
  
)

export default component.exports